import { Component, OnInit } from '@angular/core';
import {BroadcastService} from '@azure/msal-angular';
import { MsalService} from '@azure/msal-angular';

@Component({
  selector: 'app-free-trial',
  templateUrl: './free-trial.component.html',
  styleUrls: ['./free-trial.component.scss']
})
export class FreeTrialComponent implements OnInit {

  constructor(private broadcastService: BroadcastService,
              private authService: MsalService) { }

  ngOnInit() {
      this.authService.loginRedirect(['user.read']);
  }

}



// WEBPACK FOOTER //
// ./src/app/free-trial/free-trial.component.ts